import pageColumns from './pageColumns';
import pageTopicColumns from './pageTopicColumns';
import topicColumns from './topicColumns';

const inventory = { pageColumns, pageTopicColumns, topicColumns };

export { inventory };
